// constants.js
// Application-wide constants

// Import the CURRENT_DATE from utils/constants to ensure consistency
import { CURRENT_DATE } from './utils/constants';

/**
 * Current year based on CURRENT_DATE
 */
export const CURRENT_YEAR = CURRENT_DATE.getFullYear();

/**
 * Current quarter based on CURRENT_DATE
 */
export const CURRENT_QUARTER = Math.floor(CURRENT_DATE.getMonth() / 3) + 1;

/**
 * Other constants can be added here
 */
export const STANDARD_HOURS_PER_WEEK = 40;
